export const ApiStatus = {
  Loading: "loading",
  Success: "success",
  Failed: "failed",
  Forbidden: "forbidden",
  ConfigError: "configError"
};
